import React from 'react'
import ReactDOM from 'react-dom'
import {App} from './App'
import 'reportcomponents/stylesheets/vivareport.less'
import 'reportcomponents/stylesheets/navbar-reports.less'
import '../stylesheets/index.less'
import { createRoot } from 'react-dom/client'

const container = document.getElementById('root')
// create a root and render
const root = createRoot(container)
root.render(<App initProps={window.initProps} />)